var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30774 9C2.30774 5.13401 5.44175 2 9.30774 2C13.1737 2 16.3077 5.13401 16.3077 9C16.3077 10.8859 15.5619 12.5977 14.3491 13.8564C14.3149 13.8827 14.282 13.9115 14.2506 13.9429C14.2193 13.9742 14.1904 14.0072 14.1641 14.0414C12.9054 15.2542 11.1937 16 9.30774 16C5.44175 16 2.30774 12.866 2.30774 9ZM14.9254 16.0319C13.3858 17.2635 11.4328 18 9.30774 18C4.33718 18 0.307739 13.9706 0.307739 9C0.307739 4.02944 4.33718 0 9.30774 0C14.2783 0 18.3077 4.02944 18.3077 9C18.3077 11.125 17.5713 13.078 16.3396 14.6177L20.0148 18.2929C20.4054 18.6834 20.4054 19.3166 20.0148 19.7071C19.6243 20.0976 18.9912 20.0976 18.6006 19.7071L14.9254 16.0319Z",
    fill: "#1C7EBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c9e66b5d9299f60a14af298f15e277f1.svg";
export { ForwardRef as ReactComponent };